import { Employee } from 'app/shared/models/employee';

export class EmployeeVM {
  EmployeeId: number;
  PreferredFirstName: string;
  LastName: string;
  MiddleInitial: string;
  FullName: string;
  FullNameAlt: string;
  JobStatus: string;
  JobTitle: string;
  EmployeeUID: string;

  constructor(item?: Employee) {
    if (item) {
      this.EmployeeId = item.EmployeeId;
      this.PreferredFirstName = item.PreferredFirstName;
      this.LastName = item.LastName;
      this.MiddleInitial = item.MiddleName && item.MiddleName.length > 0 ? item.MiddleName.substring(0, 1) : '';
      this.FullName = `${item.LastName}, ${item.PreferredFirstName} ${this.MiddleInitial}`;
      this.FullNameAlt = `${item.PreferredFirstName} ${item.LastName}`;
      this.JobStatus = item.JobStatus;
      this.JobTitle = item.JobTitle;
      this.EmployeeUID = item.EmployeeUID;
      if (item.WorkerType && item.WorkerType !== 'Employee' && item.WorkerType !== 'Regular' && item.WorkerType !== 'Exxon_Transition_Employee')
        this.JobTitle = '[C] ' + item.JobTitle;
    }
  }
}